import { useState } from 'react';
import type { ReactElement } from 'react';

import { LottieAssets } from '@/config/lottieAssets';
import { wv } from '@/utils/screenUtil';
import { seekLottie, useAnimationController, useLottie } from '@/utils/useLottie';

/**
 * Перенос `presentation/widgets/language_switch_animation/language_lottie.dart`.
 *
 * Анимация `Language.json` бесконечно ходит вперёд-назад: дошли до конца —
 * идём к началу, и так по кругу.
 */

/** `_defaultDuration = Duration(seconds: 4)` */
const DURATION_MS = 4000;

/** `SizedBox(width: 200.w, height: 200.w)` */
const BOX_SIZE = 200;

export function LanguageLottie(): ReactElement {
  const [forward, setForward] = useState(true);
  const { containerRef, animationRef } = useLottie({
    animationData: LottieAssets.language,
  });

  useAnimationController({
    forward,
    durationMs: DURATION_MS,
    // `_onAnimationStatusChanges`: дошли до края — разворачиваемся.
    onCompleted: () => setForward((value) => !value),
    onTick: (progress) => seekLottie(animationRef.current, progress),
  });

  return (
    <div ref={containerRef} style={{ width: wv(BOX_SIZE), height: wv(BOX_SIZE) }} />
  );
}
